import { useEffect } from 'react';
import { useOpenModal } from '../next-modal';
import { LRUCache } from '../utils/lru-cache';
import localforage from 'localforage';
import { isBuildIn, isPrivate } from '../build-in';
import { appI18n } from '../i18n';

const visitedWebsite = new LRUCache<string, boolean>(localforage, 'whitelist_website', 100);
const topNWebsites = [
  'www.baidu.com',
  'qq.com',
  'sohu.com',
  '163.com',
  'sina.com.cn',
  'eastmoney.com',
  'so.com',
  'csdn.net',
  'bilibili.com',
  'sogou.com',
  'blog.csdn.net',
  'douban.com',
  '1688.com',
  'movie.douban.com',
  'weibo.com',
  'jd.com',
  'ifeng.com',
  'ctrip.com',
  '2345.com',
  'iqiyi.com',
  'pcauto.com.cn',
  'ali213.net',
  'chinaz.com',
  'autohome.com.cn',
  'zhihu.com',
  'zol.com.cn',
  'pconline.com.cn',
  'quote.eastmoney.com',
  'bendibao.com',
  '66law.cn',
  'ximalaya.com',
  'weather.com.cn',
  'kugou.com',
  '3dmgame.com',
  'iciba.com',
  'tianqi.com',
  'onlinedown.net',
  'apple.com',
  'bing.com',
  'qidian.com',
  'thepaper.cn',
  'ip138.com',
  '58.com',
  'zdic.net',
  '39.net',
  'jjwxc.net',
  'mp.weixin.qq.com',
  '500.com',
  'guba.eastmoney.com',
  'cn.bing.com',
  'cngold.org',
  'ruiwen.com',
  '64365.com',
  'maoyan.com',
  '360.cn',
  '51test.net',
  'wandoujia.com',
  'hexun.com',
  'yw11.com',
  '2265.com',
  'lottery.gov.cn',
  'diyifanwen.com',
  'zhuanlan.zhihu.com',
  'www.douyin.com',
  'tv.cctv.com',
  'cz89.com',
  'eastday.com',
  'jia.com',
  'xzw.com',
  '78500.cn',
  'buyiju.com',
  '99.com.cn',
  'cwl.gov.cn',
  '17500.cn',
  'taobao.com',
  '4399.com',
  'youdao.com',
  'youku.com',
  'chinatax.gov.cn',
  'v.qq.com',
  '360doc.cn',
  'finance.sina.com.cn',
  'cnblogs.com',
  'downcc.com',
  'dict.cn',
  'forex.hexun.com',
  'hujiang.com',
  'kuwo.cn',
  'tvmao.com',
  'maigoo.com',
  '360kan.com',
  'tencent.com',
  'www.microsoft.com',
  'anjuke.com',
  '1905.com',
  'huawei.com',
  'aizhan.com',
  'people.com.cn',
  'jianshu.com',
  'm.163.com',
  'google.cn',
  'waptianqi.2345.com',
  'dxsbb.com',
  'cncn.com',
  'y.qq.com',
  'cnki.net',
  'www.chazidian.com',
  'xinhuanet.com',
  'offcn.com',
  'you.ctrip.com',
  'docin.com',
  'hupu.com',
  'jb51.net',
  'liepin.com',
  'china.com',
  'huatu.com',
  'xueqiu.com',
  '9game.cn',
  'mafengwo.cn',
  '120ask.com',
  'wikipedia.org',
  'facebook.com',
  'reddit.com',
  'whatsapp.com',
  'openai.com',
  'play.google.com',
  'espncricinfo.com',
  'cricbuzz.com',
  'imdb.com',
  'amazon.com',
  'es.wikipedia.org',
  'translate.google.com',
  'canva.com',
  'x.com',
  'de.wikipedia.org',
  'yahoo.co.jp',
  'fr.wikipedia.org',
  'iplt20.com',
  'globo.com',
  'ja.wikipedia.org',
  'nytimes.com',
  'espn.com',
  'spotify.com',
  'netflix.com',
  'ru.wikipedia.org',
  'mayoclinic.org',
  'it.wikipedia.org',
  'linkedin.com',
  'google.com',
  'ilovepdf.com',
  'pt.wikipedia.org',
  'quora.com',
  'indeed.com',
  'uol.com.br',
  'bbc.co.uk',
  'zh.wikipedia.org',
  'detik.com',
  'hindustantimes.com',
  'clevelandclinic.org',
  'amazon.in',
  'adobe.com',
  'dpboss.boston',
  'roblox.com',
  'bbc.com',
  'indiatimes.com',
  'poki.com',
  'twitter.com',
  'ndtv.com',
  'nih.gov',
  'chatgpt.com',
  'amazon.de',
  'steampowered.com',
  'pl.wikipedia.org',
  'ikea.com',
  'yelp.com',
  'rakuten.co.jp',
  'healthline.com',
  'cookpad.com',
  'finance.yahoo.com',
  'mercadolivre.com.br',
  'id.wikipedia.org',
  'samsung.com',
  'amazon.co.jp',
  'wise.com',
  'tripadvisor.com',
  'flipkart.com',
  '365scores.com',
  'sattamatkadpboss.co',
  'booking.com',
  'indianexpress.com',
  'ar.wikipedia.org',
  'tr.wikipedia.org',
  'moneycontrol.com',
  'accuweather.com',
  'hotstar.com',
  'medlineplus.gov',
  'nba.com',
  'walmart.com',
  'www.nhs.uk',
  'trendyol.com',
  'mail.yahoo.com',
  'webmd.com',
  'nintendo.com',
  'weather.com',
  'www.gov.uk',
  'thehindu.com',
  'nike.com',
  'merriam-webster.com',
  'github.com',
  'allegro.pl',
  'altibbi.com',
  'livescore.com',
  'piazzedigitali.it',
  'mail.google.com',
  'dailymail.co.uk',
  'quizizz.com',
  'fotmob.com',
  'shabdkosh.com',
  'elcorteingles.es',
  'stackoverflow.com',
  'dikdasmen.go.id',
  'freepik.es',
  'bloomberght.com',
  'u.gg',
  'onefootball.com',
  'latamairlines.com',
  'netshoes.com.br',
  'pgatour.com',
  'clarin.com',
  'yandex.ru',
  'ozon.ru',
  'mail.ru',
  'kinopoisk.ru',
  'dzen.ru',
  'vk.com',
  'rutube.ru',
  'pinterest.com',
  'youtube.com',
  'gismeteo.ru',
  'banki.ru',
  'wildberries.ru',
  'rbc.ru',
  'ya.ru',
  'gdz.ru',
  'eapteka.ru',
  'vidal.ru',
  'instagram.com',
  'lenta.ru',
  'tbank.ru',
  'russianfood.com',
  'avito.ru',
  'ria.ru',
  'asna.ru',
  'championat.com',
  'en.wikipedia.org',
  'rambler.ru',
  'fandom.com',
  'pozdravok.com',
  '2gis.ru',
  'auto.ru',
  'consultant.ru',
  'wiktionary.org',
  'kino-teatr.ru',
  'telegram.org',
  'skysmart.ru',
  'dns-shop.ru',
  'planetazdorovo.ru',
  'sravni.ru',
  'ivi.ru',
  'ok.ru',
  'sportbox.ru',
  'smclinic.ru',
  'cbr.ru',
  'soccer365.ru',
  'gosuslugi.ru',
  'tiktok.com',
  'vseinstrumenti.ru',
  '24smi.org',
  'sports.ru',
  't.me',
  'freepik.com',
  'pikabu.ru',
  'cian.ru',
  'tripadvisor.ru',
  'rustore.ru',
  'reverso.net',
  'uchi.ru',
  'myfin.by',
  'eda.ru',
  'investing.com',
  'irecommend.ru',
  'tutu.ru',
  'sberbank.com',
  'trychatgpt.ru',
  'deepl.com',
  'skillbox.ru',
  'invitro.ru',
  'reshak.ru',
  'funpay.com',
  'gazeta.ru',
  'apteka.ru',
  'yandex.com.tr',
  'gastronom.ru',
  'domclick.ru',
  'mts.ru',
  'aliexpress.ru',
  'trashbox.ru',
  'ura.news',
  'vtb.ru',
  'iz.ru',
  'drom.ru',
  'proxifier.com',
  'znanierussia.ru',
  'google.ru',
  'mos.ru',
  'yaklass.ru',
  'kp.ru',
  'lifehacker.ru',
  'gemotest.ru',
  'sberbank.ru',
];
const getHost = (url: string) => {
  try {
    const { host } = new URL(url);
    if (host.startsWith('www.')) {
      return host.slice(4);
    }
    return host;
  } catch {
    return '';
  }
};
const allHost = topNWebsites.map((url) => {
  if (url.startsWith('www.')) {
    return url.slice(4);
  }
  return url;
});
const whiteListHostSet = new Set(allHost);
whiteListHostSet.add('flowus.cn');
whiteListHostSet.add('allflow.cn');
whiteListHostSet.add('buildin.ai');
export const useOpenExternLink = () => {
  const openModal = useOpenModal();

  useEffect(() => {
    const isExternalLink = (url: string): boolean => {
      try {
        if (
          window.location.href.includes('flowus.cn') ||
          window.location.href.includes('buildin.ai')
        ) {
          return false;
        }
        const currentHost = window.location.host;
        const targetHost = getHost(url);
        const isWhiteList = whiteListHostSet.has(targetHost);
        if (isWhiteList) return false;
        return currentHost !== targetHost;
      } catch {
        return true;
      }
    };

    const handleDocumentClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const anchor = target.closest('a'); // 获取最近的a标签
      if (!anchor) return;
      if (anchor.className.includes('ignore-security-dialog')) {
        return;
      }
      const { href } = anchor;
      if (!href || !isExternalLink(href)) return;
      if (href.startsWith('blob')) return;

      // 检查是否需要跳过确认
      if (anchor.dataset.bypassCheck) return;

      // 阻止默认行为和事件传播
      event.preventDefault();
      event.stopImmediatePropagation();

      const openUrl = () => {
        // 判断打开方式（新标签/当前页）
        const openInNewTab =
          anchor.target === '_blank' || event.ctrlKey || event.metaKey || event.button === 1; // 中键点击
        visitedWebsite.put(getHost(href), true);
        if (openInNewTab) {
          window.open(href, '_blank');
        } else {
          window.location.href = href;
        }
      };
      const alreadyVisied = visitedWebsite.get(getHost(href));
      if (alreadyVisied) {
        openUrl();
        return;
      }

      openModal.warning({
        title: <span className="text-red">{appI18n.t('pkg_common.security.warning_title')}</span>,
        colorType: 'active',
        confirmText: appI18n.t('pkg_common.btn.insist_visit') as string,
        //不知道为啥本地可以用翻译但build之后就不行，这里做下特殊对待
        content: (
          <div className="my-2.5 text-t2 w-full whitespace-pre-line break-words max-h-[50vh] overflow-y-auto">
            <div>
              {appI18n.t('pkg_common.security.visit_external_site')}
              <span>{href}</span>
            </div>
            <div>{appI18n.t('pkg_common.security.external_site_disclaimer')}</div>
          </div>
        ),
        confirm() {
          openUrl();
        },
      });
    };
    if (isBuildIn() || isPrivate()) return;

    // 捕获阶段监听点击事件
    document.addEventListener('click', handleDocumentClick, true);

    return () => {
      document.removeEventListener('click', handleDocumentClick, true);
    };
  }, [openModal]);
};
